import { isEqualByString } from 'utils/predicates/string/simple.util';

import { determineIfTimeOffMoveBlocked } from './determineIfTimeOffMoveBlocked.bl';

const isTimeOffDropInForeignColumn = ({ timeOffPerms, dropStylistId, eventStylistId }) => {
  if (!timeOffPerms?.permsActive) return false;
  if (!timeOffPerms?.isEditDurationPersonalOnly) return false;
  if (dropStylistId == null) return false;

  const ownColumnId = eventStylistId ?? timeOffPerms.accessStylistId;
  if (ownColumnId == null) return false;

  return !isEqualByString(dropStylistId, ownColumnId);
};

export const determineTimeOffMovePermissionToast = ({ timeOffPerms, eventStylistId, dropStylistId, includeDropColumn = false }) => {
  if (!timeOffPerms?.permsActive) return null;

  if (timeOffPerms.isEditDurationBlocked) {
    return { messageKey: 'scheduler.timeOffPermissions.moveNoAccessToast', toastId: 'to-move-block' };
  }

  if (determineIfTimeOffMoveBlocked({ timeOffPerms, eventStylistId })) {
    return { messageKey: 'scheduler.timeOffPermissions.personalOnlyTooltip', toastId: 'to-move-own-event' };
  }

  if (includeDropColumn && isTimeOffDropInForeignColumn({ timeOffPerms, dropStylistId, eventStylistId })) {
    return { messageKey: 'scheduler.timeOffPermissions.ownColumnMoveOnly', toastId: 'to-move-own-col' };
  }

  return null;
};
